<section class="section-card-content">
  <form [formGroup]="debitAndCreditCardForm">
    <div >
      <p class="label tw-text-[16px]" data-cy="card-deposit-amount-text">Deposit Amount</p>
      <div class="amount-row tw-relative">

        <!-- Message section -->
        <span class="tw-absolute tw-top-[-18px] tw-right-[0px] tw-h-[18px] tw-block tw-pt-[2px]">

          <!-- Required -->
          <span
            class="tw-block tw-text-right tw-text-xs tw-text-[#D83A19]"
            *ngIf="formVal['amount'] && formVal['amount']?.errors
              && (formVal['amount'].touched || formVal['amount'].dirty)"
            data-cy="card-deposit-amount-error"
          >
            {{
              formVal['amount']?.errors?.['min']
                ? 'Cannot deposit less than $25.'
                : formVal['amount']?.errors?.['max']
                  ? 'Cannot deposit greater than $500.'
                  : 'Please enter valid amount.'
            }}
          </span>
        </span>

        <input
          formControlName="amount"
          id="depositAmount"
          (keyup)="depositAmount()"
          type="number"
          min="25"
          max="500"
          class="amount tw-h-[38px] tw-text-[22px] tw-text-[#645858]"
          placeholder="25"
          pattern="^\d+(\.\d{1,2})?$"
          amwager3DecimalInput
          data-cy="card-deposit-input"
        />
      </div>
      <div class="tw-flex tw-mt-[6px] tw-mb-[22px] tw-justify-between">
        <span
          (click)="chooseAmount(500.00)"
          class="choose-amount tw-text-[16px]"
          data-cy="card-deposit-500"
        >
          $500
        </span>
        <span
          (click)="chooseAmount(200.00)"
          class="choose-amount tw-text-[16px]"
          data-cy="card-deposit-200"
        >
          $200
        </span>
        <span
          (click)="chooseAmount(100.00)"
          class="choose-amount tw-text-[16px]"
          data-cy="card-deposit-100"
        >
          $100
        </span>
        <span
          (click)="chooseAmount(50.00)"
          class="choose-amount tw-text-[16px]"
          data-cy="card-deposit-50"
        >
          $50
        </span>
        <span
          (click)="chooseAmount(25.00)"
          class="choose-amount tw-text-[16px]"
          data-cy="card-deposit-25"
        >
          $25
        </span>
      </div>

      <p class="deposit-amount tw-text-[16px]" data-cy="card-deposit-number">
        Deposit:<span class="tw-pl-[13px]">${{ (amount | number:'1.2') || '0.00' }}</span>
      </p>
      <p class="card-fee tw-text-[16px]" data-cy="card-deposit-fee">
        Card Fee:<span class="tw-pl-[4px]">${{ (fee | number:'1.2') || '0.00' }}</span>
      </p>

      <div class="mid-line"></div>

      <p class="tw-text-[19px] tw-mb-[22px]">
        <span class="total-amount" data-cy="card-deposit-total-text">Total:</span>
        <span class="tw-font-bold" data-cy="card-deposit-total-number">
          ${{ (total | number:'1.2') || '0.00' }}
        </span>
      </p>


      <div class="card-container">
        <div class="card-item tw-text-right" *ngIf="!showAddCard">
          <button
            (click)="showAddCardFn(true)"
            class="add-card active tw-w-[96px] tw-h-[41px] tw-text-[16px]"
            data-cy="card-deposit-add"
          >
            + Add
          </button>
        </div>

        <div class="card-item tw-text-right" *ngIf="showAddCard">
          <button
            (click)="showAddCardFn(false)"
            class="add-card active tw-w-[96px] tw-h-[41px] tw-text-[16px]"
            data-cy="card-deposit-close"
          >
            Close
          </button>
        </div>

        <!-- <div [hidden]="!showCard" class="eProtectiframe" id="eProtectiframe"></div> -->

        <feature-ion-add-account-card
          [hidden]="!showAddCard"
          [showAddCard]="showAddCard"
          (showAddCardFn)="showAddCardFn($event)"
        ></feature-ion-add-account-card>

      </div>

      <div class="card-content">
        <!-- <div [hidden]="!showAddCard" class="eProtectiframe" id="eProtectiframe"></div> -->

        <p class="label tw-ml-[9px]" data-cy="card-deposit-list-text">Card List</p>
        <div class="card-list-container" data-cy="card-deposit-list-table">
          <div class="card-lists">
            <div *ngIf="(cards$ | async)| isEmpty" class="empty-account tw-pl-[8px] tw-pb-[20px]">
              Please add card to deposit.
            </div>

            <div
              *ngFor="let card of cards$ | async; let i = index"
              (click)="chooseCard($event, 'debitAndCreditCard', ('card-' + i), card.OrderId)"
              id="card-{{i}}"
              class="card-per-row tw-flex tw-w-full tw-justify-between tw-items-center"
            >
              <div class="tw-flex tw-items-center tw-w-[145px]">
                <span class="selector tw-flex"></span>
                <img
                  *ngIf="card.Type === 'VI'"
                  src="/assets/images/funding/visa_icon.png"
                  alt="card logo"
                  class="card-logo tw-ml-[9px]"
                />
                <img
                  *ngIf="card.Type === 'MC'"
                  src="/assets/images/funding/mastercard_icon.png"
                  alt="card logo" class="card-logo tw-ml-[9px]"
                />
                <span class="card-name tw-text-[13px] tw-text-[#000000] tw-font-bold tw-ml-[8px]">
                  {{ card.Type | cardName }}
                </span>
              </div>

              <div class="tw-flex">
                <span class="card-ending tw-text-[12px]">
                  ending
                  <span class="tw-font-bold tw-text-[#000000]">
                    {{ card.LastFour | cardNumEnd }}
                  </span>
                </span>
              </div>

              <div class="tw-flex">
                <span class="card-date tw-text-[12px]">
                  {{ card.ExpMonth | cardDate:  card.ExpYear }}
                </span>
              </div>

              <div class="tw-flex">
                <ion-icon
                  (click)="confirmRemoveCard(card.OrderId)"
                  name="trash-outline"
                  class="delete-card tw-text-[20px] tw-t-[-2px] tw-relative">
                </ion-icon>
              </div>
            </div>
          </div>
          <!-- <div class="tw-text-right tw-py-[15px] tw-px-[18px]">
          </div> -->
        </div>

      </div>

      <button
        (click)="deposit()"
        [ngClass]="
          {'active': (amount && orderId && !awaitFee && !isDepositing && formVal['amount'].valid)}
        "
        [disabled]="!amount || !orderId || awaitFee || isDepositing || formVal['amount'].invalid"
        class="deposit-now tw-w-full tw-h-[41px] tw-text-[16px] tw-mt-[10px]"
        data-cy="card-deposit-now-button"
      >
        Deposit Now
      </button>
    </div>
  </form>
</section>
